export default __webpack_public_path__ + "static/media/30.a5367c76.png";